import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules } from '../../data/modules';
export function Included() {
  return <section className="bg-white px-5 py-7" data-id="element-82" data-mp="2snspypk3kgzh">
      <div className="mx-auto max-w-[520px]" data-id="element-83" data-mp="2xmdg1w5mxka7">
        <h2 className="text-center font-display text-[21px] uppercase leading-none text-navy md:text-[24px]" data-id="element-84" data-mp="2xllvrhhhn8z8">What’s included</h2>
        <ul className="mt-4 space-y-3.5" data-id="element-85" data-mp="32jdmi86ecp1u">
          {modules.map(m => <li key={m.number} className="rounded-[3px] border border-line border-l-[3px] bg-white px-3.5 py-2.5 shadow-[0_1px_4px_rgba(16,24,32,0.08)]" style={{
          borderLeftColor: m.accent
        }} data-id="element-86" data-mp="37k1mhjclsg87">
              <h3 className="flex items-start gap-1.5 font-display text-[12px] uppercase leading-tight text-navy" data-id="element-87" data-mp="3lbokpoq3vytm">
                <span className="mt-[1px] flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-[2px] bg-ok" data-id="element-88" data-mp="3qbklzg7f5c5h">
                  <CheckIcon className="h-2.5 w-2.5 text-white" strokeWidth={4} aria-hidden="true" data-id="element-89" data-mp="3vb6yfnffaod8" />
                </span>
                <span data-id="element-90" data-mp="2r4myooht7vln">
                  Module {m.number} — <span style={{
                color: m.accent === '#5B6E80' ? '#101820' : m.accent
              }} data-id="element-91" data-mp="2m4ijr2wjv8xj">{m.title}</span>
                </span>
              </h3>
              <p className="mt-1 text-[11px] leading-[1.55] text-muted" data-id="element-92" data-mp="2h5nylub418a9">{m.description}</p>
              <p className="mt-1 text-[9.5px] font-extrabold uppercase tracking-[0.06em] text-navy" data-id="element-93" data-mp="2d4vnswmlavbv">{m.tagline}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}